export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ03.70bfc93a.mp3";